import { getToken, setToken, removeToken } from "@/utils/token";
import { login, getUserInfo, logout } from "@/api/login/index";
import { defineStore } from "pinia";
import usePermissionStore from "./permission";
import useCacheStore from "./cache";
import defAva from "@/assets/images/profile.jpg";
import { getCacheData } from "@/utils/auth";

const useAccountStore = defineStore("account", {
  state: () => ({
    token: getToken(), // token
    userInfo: {}, // 登录账户信息
    organizationNode: {}, // 组织信息
    roleEntities: {}, // 角色信息
    avatar: "", // 显示头像
    simplePassword: getCacheData("simplePassword") === "true" ? true : false, // 是否简单密码
  }),
  actions: {
    // 登录
    login(data) {
      return new Promise((resolve, reject) => {
        login(data)
          .then(async (res) => {
            setToken(res.token); // 存储token
            this.token = res.token; // 更新state中的token
            await this.setCacheData(res);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取用户信息
    getUserInfo() {
      return new Promise((resolve, reject) => {
        getUserInfo().then(async (res) => {
          await this.setCacheData(res);
          resolve();
        });
      });
    },
    // 退出登录
    logOut(type) {
      return new Promise((resolve, reject) => {
        if (!type) {
          logout().finally((data) => {
            removeToken(); // 移除token
            resolve();
          });
        } else {
          removeToken(); // 移除token
          resolve();
        }
      });
    },
    // 登录后获取账户信息，缓存数据
    async setCacheData(res) {
      this.userInfo = res.data.userEntity; // 更新用户信息
      this.organizationNode = res.data.organizationNode; // 更新组织架构信息
      this.roleEntities = res.data.roleEntities; // 更新角色信息
      const avatar = defAva;
      this.avatar = avatar; // 更新头像
      // 获取需要缓存的数据
      await useCacheStore().getCache();
      // 更新权限
      await usePermissionStore().generateRoutes(
        res.data.operationEntities,
        res.data.roleEntities,
        this.userInfo.admin === "1" ? true : false
        // true
      );
    },
    // 移除缓存数据
    removeCacheData() {
      this.userInfo = {};
      // 移除权限缓存
      usePermissionStore().removeData();
    },
  },
});

export default useAccountStore;
